import { writable } from 'svelte/store';

// 기본값을 'false'로 설정
export const isPublishPopup = writable(false);
export const isRevision = writable(false);

// 자동 저장 상태 표시용: 'idle' | 'saving' | 'saved'
// chat.save()가 'saving' → 성공 시 'saved'(잠깐) → 'idle'로 되돌린다. 헤더 인디케이터가 구독.
export const saveStatus = writable("idle");
let _savedTimer;
export const markSaving = () => {
	clearTimeout(_savedTimer);
	saveStatus.set("saving");
	// 저장 실패 등으로 markSaved가 안 불릴 때 pill이 'saving'에 갇히지 않도록 안전장치(자가치유)
	_savedTimer = setTimeout(() => saveStatus.set("idle"), 8000);
};
export const markSaved = () => {
	saveStatus.set("saved");
	clearTimeout(_savedTimer);
	_savedTimer = setTimeout(() => saveStatus.set("idle"), 1800);
};
export const markSaveIdle = () => {
	clearTimeout(_savedTimer);
	saveStatus.set("idle");
};